import React, { useEffect, useState } from "react";
import {Button, Icon, Modal, Popup} from "semantic-ui-react";
import {API_URL} from "../../constant";
import api from "../../action/api";

type Props = {
    nlpSourceType: string
    nlpSourceId: string
    isClosable?: boolean
    showIcon?: boolean
}

function EvidenceViewer(props: Props): JSX.Element {
    const { nlpSourceType, nlpSourceId, isClosable, showIcon } = props
    const [open, setOpen] = useState<boolean>(false)
    const [ isLoading, setIsLoading ] = useState<boolean>(false)
    const [modalContentUrl, setModalContentUrl] = useState<string>('')
    const [ openError, setOpenError ] = useState<boolean>(false)

    useEffect(() => {
        if (showIcon) {
            fetchDataAndOpenModal()
        }
    },  [])

    async function fetchDataAndOpenModal() {
        try {
            setIsLoading( true )
            const viewerUrl = await fetchViewerUrl(nlpSourceType, nlpSourceId)
            setModalContentUrl(viewerUrl)
            setIsLoading( false )
            setOpen(true)
        } catch (error) {
            setOpenError(true)
            console.error('Error fetching modal URL:', error)
        }
    }

    const handleCloseModal = () => {
        setOpen(false)
        setModalContentUrl('')
    };

    const handleCloseErrorModal = () => {
        setOpenError(false)
    };

    return (
        <>
            <span>
                { !showIcon && <Popup 
                    content='Evidence Viewer' 
                    trigger={
                        <Icon 
                            id={`cdaOpenModalButton-${nlpSourceId}`}
                            onClick={ async(e:any) => await fetchDataAndOpenModal() } 
                            disabled={ isLoading } 
                            name="magnify" 
                            className="pointer" />} 
                />}
            </span>
            <Modal
                closeIcon={isClosable}
                open={open}
                onClose={handleCloseModal}
                closeOnDimmerClick={isClosable}
            >
                {modalContentUrl ? (
                    <iframe src={modalContentUrl} style={{width: '100%', height: '600px', border: 'none'}}/>
                ) : (
                    <p>Loading content...</p>
                    
                )}
            </Modal>
            <Modal
                open={openError}
                onClose={handleCloseErrorModal}
                size="mini"
                basic
            >
                <Modal.Header icon>
                    <Icon name='file alternate outline' />
                    Chart Document Not Found
                </Modal.Header>
                <Modal.Actions>
                    <Button
                        id="coder-encounter-lock-failure-modal"
                        color="green"
                        onClick={handleCloseErrorModal}
                        inverted
                    >
                        <Icon name="checkmark" /> Ok
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
}

async function fetchViewerUrl(
    nlpSourceType: string,
    nlpSourceId: string): Promise<string> { 
    const viewerUrl = nlpSourceType === 'pdf' ?  API_URL.PDF_VIEWER_URL : API_URL.MDP_VIEWER_URL
    return await api
            .get(viewerUrl(nlpSourceId))
            .then(response => response.data)
    }


export default EvidenceViewer;
